import React, { useMemo } from 'react';
import cn from 'classnames';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import { useChartContext } from '../../hooks';
import { getVisibleData, getVisibleDates } from '../../helpers';

import styles from './styles.styl';

const ChartHeaderFixed = ({ config }) => {
  const {
    mark,
    range,
    period,
    sources,
    formats,
    activeSource,
    converter = noop,
  } = useChartContext();

  const filteredSources =
    activeSource && sources.includes(activeSource) ? [activeSource] : sources;

  const data = useMemo(() => getVisibleData(config, filteredSources), [
    config,
    filteredSources,
  ]);

  const dates = useMemo(() => getVisibleDates(config, period), [
    config,
    period,
  ]);

  return (
    <div className={styles.header}>
      <div>
        <b>{converter.func(Object.fromEntries(data))} </b>
        <span className={cn(styles.sub, styles.light)}>{mark}</span>
      </div>
      <div className={styles.info}>
        <div className={styles.sub}>
          {range} {dates.map(date => date.toLowerCase()).join(' - ')}
        </div>
        <div className={cn(styles.sub, styles.light)}>
          {!activeSource ? formats.all : formats[activeSource]}
        </div>
      </div>
    </div>
  );
};

ChartHeaderFixed.propTypes = {
  config: PropTypes.object,
};

export default ChartHeaderFixed;



// WEBPACK FOOTER //
// ./src/components/common/Charts/ChartWrapper/ChartHeaderFixed/index.jsx